<template>
  <v-snackbar-queue
    v-model="snackbar.queue"
    location="bottom center"
    closable
  >
    <template #actions="{ props }">
    <v-btn icon v-bind="props" :aria-label="$t('general.close')">
      <v-icon icon="mdi-close" />
    </v-btn>
  </template>
  </v-snackbar-queue>
</template>

<script setup>
import { useSnackbarStore } from '@/stores/snackbarStore.js'
const snackbar = useSnackbarStore()


</script>
